import { useBoundContext } from "lib/@components/binding/use-bound-context"

/**
 * Retrieves the target from the bound context
 *
 * @return {any} The target retrieved from the bound context.
 */
export function useTarget() {
    const { target } = useBoundContext()
    return target
}
